import React, {FC} from 'react'

import {logErrorAndShowException} from 'src/lib/errors'

import {useCassandraMutation} from '@possible/cassandra/src/utils/hooks'

import {MilitarySurveyTemplate} from 'src/products/general/MilitarySurvey/MilitarySurveyTemplate'
import {AcceptNotMilitaryDocument} from 'src/products/general/MilitarySurvey/MilitarySurvey.gqls'

type MilitarySurveyGQLContainerProps = {
  onContinue: (isMilitary: boolean) => Promise<void>
}

const MilitarySurveyGQLContainer: FC<MilitarySurveyGQLContainerProps> = ({onContinue}) => {
  const [acceptNotMilitary] = useCassandraMutation(AcceptNotMilitaryDocument)

  const handleOnContinue = async (isMilitary: boolean): Promise<void> => {
    // return early if isMilitary is true. We will not send a mutation to the backend
    // Instead, frontEnd will navigate you to the MilitaryNotEligible screen.
    if (isMilitary === true) {
      await onContinue(true)
      return
    }

    try {
      const response = await acceptNotMilitary()

      if (response?.errors && response?.errors?.length > 0) {
        throw new Error(`GraphQL Error: ${response.errors[0].message}`)
      }
      await onContinue(isMilitary)
    } catch (error) {
      await logErrorAndShowException(
        error,
        'AcceptNotMilitary mutation failed in MilitarySurveyGQLContainer',
      )
    }
  }

  return <MilitarySurveyTemplate onContinue={handleOnContinue} />
}

export {MilitarySurveyGQLContainer}
